module.exports = __webpack_public_path__ + "static/media/1.53e8c3ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/1.jpg
// module id = 871
// module chunks = 0